import axios from "axios";
import { Notification } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 100000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = getToken();
    }
    if (store.getters.uniqueId) {
      config.headers["UniqueId"] = store.getters.uniqueId;
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    if (response.config.responseType === "blob") {
      const contentType =
        response.headers["content-type"] || response.headers["Content-Type"];
      if (contentType && contentType.includes("application/json")) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const data = JSON.parse(reader.result);
              resolve(data);
            } catch {
              resolve(response);
            }
          };
          reader.readAsText(response.data);
        });
      }
      return response;
    }
    const res = response.data;

    if (res.code === 401) {
      Notification({
        title: "注意",
        type: "error",
        message: res.message,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 4000,
        customClass: "notify-error-title",
      });
      setTimeout(() => {
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        });
      }, 1500);
    } else {
      const notifyConfig = {
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 4000,
      };
      const typeConfig = {
        SUCCESS: { type: "success", customClass: "notify-success-title" },
        FAIL: { type: "error", customClass: "notify-error-title" },
        "SUCCESS-ShenFang": {
          type: "success",
          customClass: "notify-success-title",
        },
        "WARRING-ShenFang": {
          type: "warning",
          customClass: "notify-warning-title",
        },
        "FAIL-ShenFang": { type: "error", customClass: "notify-error-title" },
      };
      const config = typeConfig[res.message.type];
      if (config) {
        let message = res.message.message;
        if (res.message.type.includes("ShenFang")) {
          const [name, gender, age, time, id] = res.message.message.split("|");
          message = `<div style="font-weight: 400;font-size: 14px;color: #606266;">
                        <div>用药人信息：${name} ${gender} ${age}</div>
                        <div>开具时间：${time}</div>
                        <div>处方编号：${id}</div>
                     </div>`;
        }
        Notification({
          title: res.message.title,
          type: config.type,
          message,
          ...notifyConfig,
          customClass: config.customClass,
        });
      }
      return res;
    }
  },
  (error) => {
    Notification({
      title: "注意",
      type: "error",
      message: error.message,
      dangerouslyUseHTMLString: true,
      position: "bottom-right",
      duration: 4000,
      customClass: "notify-error-title",
    });
    return Promise.reject(error);
  }
);

export default service;
